import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, Form, FormGroup, Label, Input } from "reactstrap";
import { Calendar } from "react-date-range";
import { enGB, srLatn } from "date-fns/locale";
import { format } from "date-fns";

import apiRequest from "../../api";
import "./modals.css"

const EmailReportModal = ({ isOpen, toggle, selectedUsers }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'EN';
    });
    const locale = selectedLanguage === 'RS' ? srLatn : enGB;
    const [isStartCalendarOpen, setIsStartCalendarOpen] = useState(false);
    const [isEndCalendarOpen, setIsEndCalendarOpen] = useState(false);

    const calendarStartRef = useRef(null);
    const calendarEndRef = useRef(null);
    const [formDetails, setFormDetails] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });
    useEffect(() => {
        setSelectedLanguage(localStorage.getItem('Language') || 'EN');
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Selected users:", selectedUsers);
        // Create the request body
        const formatDateForAPI = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            usernames: selectedUsers,
            startDate: formatDateForAPI(formDetails.startDate),
            endDate: formatDateForAPI(formDetails.endDate)
        };
        

        // Make the POST request
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const response = await apiRequest('/api/reservations/exportReservations', 'POST', requestBody, token);

            toggle(); // Close the modal after successful submission
        } catch (error) {
            try {
                // Parse the error message
                const errorData = JSON.parse(error.message);
                if (errorData.Body && errorData.Body.error) {
                    window.alert(errorData.Body.error); // Display the error message
                }
            } catch (parseError) {
                console.error("Failed to parse error message:", parseError);
            }
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarStartRef.current &&
                !calendarStartRef.current.contains(event.target) // Check if click is outside
            ) {
                setIsStartCalendarOpen(false);
            }
            if (
                calendarEndRef.current &&
                !calendarEndRef.current.contains(event.target) // Check if click is outside
            ) {
                setIsEndCalendarOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className="custom-modal"
            style={{ width: "350px", margin: '1.75rem auto', position: 'relative' }}
            backdrop="static" // This prevents closing when clicking outside
            keyboard={false} // This prevents closing when pressing ESC key
        >
            <ModalBody className="text-center">
                <div className="row justify-content-center mb-2"  >
                    <div className="col-md-6" ref={calendarStartRef} style={{width: "100%"}}>
                        <FormGroup className="modal-date" style={{ justifyContent: "center", alignItems: "center", width: "100%" }}>
                            <Label>
                                {selectedLanguage === "EN" ? "Start Date" : "Početni Datum"}
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={format(formDetails.startDate, "dd.MM.yyyy")}
                                onClick={() => setIsStartCalendarOpen(!isStartCalendarOpen)}
                                readOnly
                                style={{ cursor: "pointer", borderRadius: 5, textAlign: "center", width: "80%", margin: "0 auto" }}
                            />
                            <div className="calendar-container">
                                {isStartCalendarOpen && (
                                    <Calendar
                                        date={formDetails.startDate}
                                        onChange={(date) => {
                                            setFormDetails((prevDetails) => ({
                                                ...prevDetails,
                                                startDate: date, // Update the date
                                            }));
                                            setIsStartCalendarOpen(false);
                                        }}
                                        locale={locale}
                                        color="rgba(13, 114, 72, 0.4)"
                                        className="calendar-container"
                                        style={{
                                            '--rdrDayToday-border-color': 'green',
                                        }}
                                    />
                                )}
                            </div>
                        </FormGroup>
                    </div>
                </div>
                <div className="row justify-content-center mb-2"  >
                    <div className="col-md-6" ref={calendarEndRef} style={{ width: "100%" }}>
                        <FormGroup className="modal-date">
                            <Label>
                                {selectedLanguage === "EN" ? "End Date" : "Krajnji Datum"}
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={format(formDetails.endDate, "dd.MM.yyyy")}
                                onClick={() => setIsEndCalendarOpen(!isEndCalendarOpen)}
                                readOnly
                                style={{ cursor: "pointer", borderRadius: 5, textAlign: "center", width: "80%", margin: "0 auto" }}
                            />
                            <div className="calendar-container">
                                {isEndCalendarOpen && (
                                    <Calendar
                                        date={formDetails.endDate}
                                        onChange={(date) => {
                                            setFormDetails((prevDetails) => ({
                                                ...prevDetails,
                                                endDate: date, // Update the date
                                            }));
                                            setIsEndCalendarOpen(false);
                                        }}
                                        locale={locale}
                                        color="rgba(13, 114, 72, 0.4)"
                                        className="calendar-container"
                                        style={{
                                            '--rdrDayToday-border-color': 'green',
                                        }}
                                    />
                                )}
                            </div>
                        </FormGroup>
                    </div>
                </div>
                <FormGroup>
                    <div className="row">
                        <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                            <button
                                className="model-btn-cancel btn btn-secondary py-1 px-5"
                                onClick={toggle}
                                type="button"
                            >
                                {selectedLanguage === "EN" ? "Cancel" : "Otkaži"}
                            </button>
                        </div>
                        <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                            <button
                                className="model-btn btn btn-primary py-1 px-5"
                                onClick={handleSubmit}
                            >
                                {selectedLanguage === "EN" ? "Send" : "Pošalji"}
                            </button>
                        </div>
                    </div>
                </FormGroup>
            </ModalBody>
        </Modal>
    );
};

export default EmailReportModal;